if (!customElements.get('br-free-shipping-progress')) {
  class BrFreeShippingProgress extends HTMLElement {
    connectedCallback() {
      this.threshold = Number.parseInt(this.dataset.thresholdCents, 10);
      this.initialSubtotal = Number.parseInt(this.dataset.subtotalCents, 10) || 0;
      this.status = this.querySelector('[data-shipping-status]');
      this.fill = this.querySelector('[data-shipping-fill]');
      this.track = this.querySelector('[role="progressbar"]');
      this.note = this.querySelector('[data-shipping-note]');
      this.check = this.querySelector('[data-shipping-check]');
      this.requestId = 0;

      if (!this.threshold || !this.status || !this.fill || !this.track) return;

      this.render(this.initialSubtotal, this.dataset.currency);

      if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined' && PUB_SUB_EVENTS.cartUpdate) {
        this.unsubscribe = subscribe(PUB_SUB_EVENTS.cartUpdate, () => this.refresh());
      }

      this.pageShowHandler = (event) => {
        if (event.persisted) this.refresh();
      };
      window.addEventListener('pageshow', this.pageShowHandler);
    }

    disconnectedCallback() {
      if (this.unsubscribe) this.unsubscribe();
      window.removeEventListener('pageshow', this.pageShowHandler);
    }

    async refresh() {
      const requestId = ++this.requestId;

      try {
        const response = await fetch(`${this.dataset.cartUrl}.js`, {
          credentials: 'same-origin',
          headers: { Accept: 'application/json' },
        });
        if (!response.ok) return;

        const cart = await response.json();
        if (requestId !== this.requestId) return;

        this.render(cart.total_price || 0, cart.currency || this.dataset.currency);
      } catch (error) {
        // The server-rendered cart value remains visible if a refresh fails.
      }
    }

    render(subtotal, currency) {
      const remaining = Math.max(this.threshold - subtotal, 0);
      const percent = Math.min(Math.max((subtotal / this.threshold) * 100, 0), 100);
      const unlocked = remaining === 0;

      if (unlocked) {
        this.status.textContent = 'FREE SHIPPING UNLOCKED';
      } else if (subtotal === 0) {
        this.status.textContent = `ADD ${this.formatMoney(this.threshold, currency)} FOR FREE SHIPPING`;
      } else {
        this.status.textContent = `${this.formatMoney(remaining, currency)} AWAY FROM FREE SHIPPING`;
      }

      this.classList.toggle('is-unlocked', unlocked);
      if (this.check) this.check.hidden = !unlocked;
      this.fill.style.width = `${percent}%`;
      this.track.setAttribute('aria-valuenow', Math.round(percent).toString());
      if (this.note) this.note.hidden = unlocked;
    }

    formatMoney(cents, currency) {
      try {
        return new Intl.NumberFormat(this.dataset.locale || document.documentElement.lang || 'en', {
          style: 'currency',
          currency,
        }).format(cents / 100);
      } catch (error) {
        return `$${(cents / 100).toFixed(2)}`;
      }
    }
  }

  customElements.define('br-free-shipping-progress', BrFreeShippingProgress);
}
